import { bindActionCreators } from "redux";
import { call, put, take } from "redux-saga/effects";

import * as apiCaller from "../../api/apiCaller";

export const GET_CONFIG_TIME = "GET_CONFIG_TIME";
export const GET_CONFIG_TIME_ERROR = "GET_CONFIG_TIME_ERROR";
export const GET_CONFIG_TIME_SUCCESS = "GET_CONFIG_TIME_SUCCESS";

export const CONFIG_TIME = "CONFIG_TIME";
export const CONFIG_TIME_ERROR = "CONFIG_TIME_ERROR";
export const CONFIG_TIME_SUCCESS = "CONFIG_TIME_SUCCESS";

/**
 * Reducer
 */

const initialState = {
  times: [],
  error: false,
  loading: false,
};

export const timeRingReducer = (state = initialState, action) => {
  switch (action.type) {
    //get time
    case GET_CONFIG_TIME:
      return {
        ...state,
      };
    case GET_CONFIG_TIME_SUCCESS:
      return {
        ...state,
        times: action.payload,
      };
    case GET_CONFIG_TIME_ERROR:
      return {
        ...state,
        error: action.error,
      };

    //config time
    case CONFIG_TIME:
      return {
        ...state,
        loading: true,
      };
    case CONFIG_TIME_SUCCESS:
      return {
        ...state,
        // time: action.payload,
        loading: false,
      };
    case CONFIG_TIME_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
};

/**
 * Action
 */
export const getConfigTime = () => ({
  type: GET_CONFIG_TIME,
});

export const configTime = (id, defaultValue) => ({
  type: CONFIG_TIME,
  data: {
    id,
    defaultValue,
  },
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      getConfigTime,
      configTime,
    },
    dispatch
  );
};

/**
 * Apis
 */

const getConfigTimeApi = () => {
  return apiCaller.get("/cloud-pbx/config");
};

const configTimeApi = (id, defaultValue) => {
  return apiCaller.put(`/cloud-pbx/config/${id}`, { defaultValue });
};

/**
 * sagas
 */

export const getConfigTimeFlow = function* () {
  while (true) {
    yield take(GET_CONFIG_TIME);
    try {
      const res = yield call(getConfigTimeApi);
      yield put({ type: GET_CONFIG_TIME_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: GET_CONFIG_TIME_ERROR, error });
    }
  }
};

export const configTimeFlow = function* () {
  while (true) {
    const action = yield take(CONFIG_TIME);
    try {
      const res = yield call(
        configTimeApi,
        action.data.id,
        action.data.defaultValue
      );
      yield put({ type: CONFIG_TIME_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: CONFIG_TIME_ERROR, error });
    }
  }
};
